import { render } from "./TabPassword.vue?vue&type=template&id=4a6f8e62"
import script from "./TabPassword.vue?vue&type=script&lang=js"
export * from "./TabPassword.vue?vue&type=script&lang=js"

import "./TabPassword.vue?vue&type=style&index=0&id=4a6f8e62&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__